import React from 'react';
import './CardExpertise.css';

const CardExpertise = (props) => {
    return (
        <div className={`cardExpertise-container ${props.backgroundColor}`}>
            <img className='cardExpertise-image' src={props.illustration} alt="Illustration" />
            <h3 className='cardExpertise-title'>{props.title}</h3>
            <p className='cardExpertise-content'>{props.children}</p>
            <a className='cardExpertise-link' href={props.anchor}><span>EN SAVOIR PLUS</span></a>
        </div>
    )
};

export default CardExpertise;